import { Common } from '~/models/common';

export namespace ServicesGroup {
	export const collection = 'services_group';
	export const api = `/api/${collection}`;

	export type Model = Common.Model & {
		name: string | null;
		pageView: boolean;
	};

	export const modelState: Model = {
		...Common.modelState,
		name: null,
		pageView: false,
	};
}
